module.exports = __webpack_public_path__ + "static/media/trophy.ea43f92e.png";